import { useQuery } from '@tanstack/react-query';
import type { LineageGraphResponse, LineageGraphSource } from '../types';
import { getLineageGraphView } from '../utils/lineageGraphResponse';

type Options = {
  enabled: boolean;
  forceLoadLargeGraph?: boolean;
  keepPreviousData?: boolean;
};

const useBaseLineageGraphQuery = <T extends LineageGraphResponse>(
  source: LineageGraphSource<T> | undefined,
  { enabled, forceLoadLargeGraph = false, keepPreviousData }: Options,
) => {
  const view = getLineageGraphView({ forceLoadLargeGraph });

  return useQuery({
    queryKey: [...(source?.queryKey ?? []), view],
    queryFn: async () => (source ? source.fetchGraph(view) : null),
    enabled: enabled && !!source,
    staleTime: Infinity,
    keepPreviousData,
  });
};

export default useBaseLineageGraphQuery;
